import styled from "styled-components";
import { amountFormat } from "../../../Component/tool/Tools";

export default function RemainingStock({ count, price }: { count?: number; price?: number }) {
  const remaining = Math.max(0, Number(count) || 0);
  if (price !== undefined) {
    const stockKnown = count != null && Number.isFinite(Number(count));
    return <Metrics className="broadcast-product-metrics">
      <Metric $soldOut={stockKnown && remaining === 0} role="status" aria-label={stockKnown ? `남은 수량 ${remaining}개` : '남은 수량 확인 중'}>
        <span>남은 수량</span><strong>{stockKnown ? <>{amountFormat(remaining)}<small>개</small></> : '확인 중'}</strong>
      </Metric>
      <Metric $soldOut={false} role="status" aria-live="off" aria-label={`판매가 ${amountFormat(price)}원`}>
        <span>판매가</span><strong>{amountFormat(price)}<small>원</small></strong>
      </Metric>
    </Metrics>;
  }
  return <Badge $soldOut={remaining === 0} role="status" aria-label={`남은 수량 ${remaining}개`}>
    <span>남은 수량</span>
    <strong>{amountFormat(remaining)}<small>개</small></strong>
  </Badge>;
}

const Metrics = styled.div`
  grid-column: 1 / -1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 16px;
  padding: 4px 12px;
  background: var(--admin-theme-accent-soft, var(--user-accent-soft, #f0eaff));
`;
const Metric = styled.div<{ $soldOut: boolean }>`
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: ${props => props.$soldOut ? 'var(--admin-theme-danger, var(--user-error, #bb2536))' : 'var(--admin-theme-link, var(--user-accent, #5425be))'};
  white-space: nowrap;
  span { font-size: calc(13px * var(--studio-font-scale, 1)); font-weight: 600; }
  strong { font-size: calc(22px * var(--studio-font-scale, 1)); font-weight: 700; line-height: 1.15; font-variant-numeric: tabular-nums; }
  small { margin-left: 2px; font-size: calc(14px * var(--studio-font-scale, 1)); font-weight: 600; }
`;

const Badge = styled.div<{ $soldOut: boolean }>`
  flex: 0 0 auto;
  min-width: 72px;
  box-sizing: border-box;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 8px 10px;
  background: ${props => props.$soldOut ? "var(--admin-theme-danger-soft, var(--user-error-soft, #fff0f0))" : "var(--admin-theme-accent-soft, var(--user-accent-soft, #f0eaff))"};
  color: ${props => props.$soldOut ? "var(--admin-theme-danger, var(--user-error, #bb2536))" : "var(--admin-theme-link, var(--user-accent, #5425be))"};
  white-space: nowrap;
  span { font-size: 12px; font-weight: 600; }
  strong { font-size: 24px; font-weight: 800; line-height: 1.15; font-variant-numeric: tabular-nums; }
  small { margin-left: 2px; font-size: 14px; font-weight: 700; }
`;
